var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPath13(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.588,
    height: 23.616,
    viewBox: "0 0 23.588 23.616",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M452.911,102.155c0,.173,0,.325,0,.477,0,2.177,0,4.354-.014,6.531a2.477,2.477,0,0,1-2.569,2.58c-1.18.009-2.359.006-3.539,0-.643,0-.88-.24-.882-.9,0-1.686,0-3.371,0-5.057,0-1.061-.393-1.455-1.442-1.457-.576,0-1.152,0-1.727,0a1.193,1.193,0,0,0-1.37,1.368c-.01,1.6-.005,3.2-.007,4.8,0,1.133-.111,1.241-1.255,1.241q-1.475,0-2.949,0a2.572,2.572,0,0,1-2.8-2.809c-.005-2.135,0-4.27-.005-6.405,0-.124-.012-.247-.018-.364a7.546,7.546,0,0,1-.926-.153,2.162,2.162,0,0,1-.973-3.581c.572-.618,1.186-1.2,1.782-1.793q3.844-3.843,7.689-7.685a2.269,2.269,0,0,1,3.513.017q4.6,4.607,9.207,9.206a2.4,2.4,0,0,1,.792,1.874,2.089,2.089,0,0,1-1.77,2.009C453.426,102.1,453.2,102.12,452.911,102.155Z",
    transform: "translate(-431.831 -88.134)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPath13);
export default __webpack_public_path__ + "static/media/Path 13.3d7254893c93cfa27816ebff9e76f5bc.svg";
export { ForwardRef as ReactComponent };